import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See {@link SvgIcon} base class for all `propTypes`.
 *
 * @type {Object}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Function component rendering the icon for Next rest.
 *
 * @param {Object} [props] - The icon component properties.
 * @returns {React.ReactElement} A SVG element.
 *
 * @see SvgIcon
 * @example
 * <NextRestIcon width={12} />
 */
const NextRestIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M42.84,23.38a2.37,2.37,0,0,0-2.6.16,11.37,11.37,0,0,1-15.9-15.9,2.4,2.4,0,0,
            0-2.15-3.82,20.1,20.1,0,0,0-2.53,39.64,20.21,20.21,0,0,0,11.21-.71A20.12,20.12,
            0,0,0,44.05,25.69,2.38,2.38,0,0,0,42.84,23.38Zm-6.7,9.82A15.3,15.3,0,1,1,14.68,
            11.73a15.49,15.49,0,0,1,3.3-2A16.17,16.17,0,0,0,38.09,29.89,15.15,15.15,0,0,1,
            36.14,33.2Z`}
        />
    </SvgIcon>
)

NextRestIcon.defaultProps = defaultProps

export { NextRestIcon }
